<template>
    <div class="wrap">
        <div class="head">
            <banner></banner>
        </div>
        <div class="condition">
            <span>提示：请根据姓名/省份/rpm进行条件选择</span>

            <li class="condition-input" @click="handleCondition">
                <span>选择</span>
                <input v-model="condition" type="text" readonly>
                <label></label>
            </li>

            <mt-popup class="popup" v-model="conditionVisible" popup-transition="popup-fade" closeOnClickModal="true"
                      position="bottom">
                <mt-picker :slots="conditionSlots" @change="conditionChange" showToolbar>
                    <div class="picker-toolbar-title">
                        <div class="usi-btn-cancel" @click="conditionCancel">取消</div>
                        <div class="">请选择</div>
                        <div class="usi-btn-sure" @click="conditionConfirm">确定</div>
                    </div>
                </mt-picker>
            </mt-popup>

            <div class="condition-input" v-if="conditionValue">
                <span>输入</span>
                <input v-model="value" type="text" :placeholder="placeholder">
                <span style="opacity: 0"></span>
            </div>

            <div class="condition-submit" @click="handlerClick">
                <button>查询</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    export default {
        components:{
            Banner
        },
        data() {
            return {
                province:'',
                rpm:'',
                rep:'',
                conditionSlots: [
                    {
                        values: []
                    }
                ],
                placeholder:"",
                conditionVisible:false,
                conditionValue:false,
                condition:"",
                value:"",
                placeHolderAgent:"",
                type:this.$route.query.type
            }
        },
        methods: {
            conditionChange(picker, values) {
                this.condition = values[0]
                this.placeHolderAgent = "请输入"+this.condition
            },
            conditionConfirm(){
                this.conditionVisible = false;
                this.conditionValue = true;
                this.placeholder = this.placeHolderAgent
            },
            conditionCancel(){
                this.conditionVisible = false;
            },
            handleCondition(){
                this.conditionVisible = true;
                this.conditionSlots[0].values=["姓名","省份","rpm"]
            },
            handlerClick(){
                console.log(this.condition,this.value)
                if(this.condition===undefined){
                    this.$toast("请选择条件")
                    return
                }
                if(this.value===""){
                    this.$toast("请输入条件")
                    return
                }

                let type=0;
                if(this.condition=="省份"){
                    type=1
                }else if(this.condition=="rpm"){
                    type=2
                }else{
                    type=3
                }
                this.$router.push({path: "repSearchResult", query: {type: type, value: this.value,sort:this.type}})
            },
        },
    };
</script>

<style lang="scss" scoped>
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: scroll;
    }

    .condition{
        width: 90%;
        height: 40%;
        margin: 0 auto;
        >span{
            color: grey;
            font-size: 14px;
        }
    }

    .condition .condition-input {
        width: 100%;
        margin: 20px  0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #C3E7DD;
        border-radius: 10px;
        height: 35px;
        font-size: 16px;
        >span{
            margin-left: 10px;
            width: 50px;
            color: #035732;
        }
        >input{
            width:  100%;
            outline: none;
            border-style: none;
            background: none;
        }
        >label{
            width: 10px;
            height: 10px;
            border-top: 2px solid #2c9a58;
            border-right: 2px solid #2c9a58;
            margin-right: 20px;
            transform:rotate(45deg);
        }
    }
    .condition-submit{
        margin: 10px  0;
        display: flex;
        justify-content: center;
        align-items: center;
        >button{
            height: 35px;
            line-height: 35px;
            width: 100%;
            border-radius: 10px;
            color: #fff;
            border-style: none;
            background: #2c9a58;
            font-size: 20px;
            /*padding: 5px 0;*/
        }
    }
    .select-condition{
        width:100%;
        height:80px;
        border:1px solid #ccc;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .condition-title {
        width: 33.33%;
        text-align: center;
        height: 80px;
        line-height: 80px;
        font-size: 32px;
        font-weight: bold;
        color: #035732;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    li{
        width: 100%;
    }



    .popup {
        width: 100%;
    }
    .condition-title{
        font-size: 16px;
    }
    .picker-toolbar-title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }
    .usi-btn-cancel,
    .usi-btn-sure {
        color: #2c9a58;
    }

    input{
        font-size: 16px;
    }
</style>

